import React from 'react';

export const SproutSocialLogo = ({
  height = 28,
  width = 28,
}: {
  height?: number;
  width?: number;
}) => (
  <svg
    viewBox="0 0 1285 1595"
    height={height}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#59cb59"
      d="m1282.2 0v737.8c0 302.2-245.7 548.2-547.5 548.2h-376.7l-297.2 297.4c-21 23.5-60.8 7.1-60.8-25.7v-1009.6c0-302.2 245.7-548.1 547.5-548.1z"
    />
    <path fill="#0ca750" d="m257.4 1389l-170.8-103h273.7z" />
    <path fill="#2bb656" d="m547.5 737.8v-737.8h737.1z" />
    <path
      fill="#0ca750"
      d="m547.5 737.8l-547.5 548.2v-737.9c0-302.2 245.7-548.1 547.5-548.1z"
    />
    <path fill="#75dd66" d="m1284.6 737.8h-737.1l737.1-737.8z" />
  </svg>
);
